export default "__VITE_ASSET__mhweyanc__"